<template>
  <roe-error-message :field="design.auto_enroll_type">
    <roe-radio-input
      v-model="design.$model.auto_enroll_type"
      label1="Pre-Tax"
      label2="Roth"
    ></roe-radio-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
import { AutoEnrollmentMixin } from "@/components/_shared/inputs/design/_mixins";
export default {
  name: "RoeAutoEnrollmentContributionTypeRadio",
  components: { RoeRadioInput, RoeErrorMessage },
  mixins: [AutoEnrollmentMixin],
  props: {
    design: Object
  }
};
</script>
